import Header from '../../__Layout/Header';
import React , {useState} from "react";
import Loader from '../../utils/Loader';
import { useGetEnrollmentQuery } from "../../Services/api";
import DeleteEnroll from './DeleteEnroll';
import {pageUrl,pageSize} from "../../utils/constants/constants";
import AddEnroll from './AddEnroll';
export default function EnrollStudent() {
    const [page, setPage] = useState(0);
    const [search, setSearch] = useState("");
    const {
        data: getEnrollment,
        isLoading: isGetLoading,
      } = useGetEnrollmentQuery({ pageUrl, params:  {search,page,pageSize}  });
      const getPrevious= () => {
        setPage(page-1);
        setSearch("");
      }
      const getNext=()=>{
        setPage(page+1);
        setSearch("");
      }
      const findSearch=(e)=>{
        setPage(0);
        setSearch(e.target.value);
      }
      if(isGetLoading) return  <Loader></Loader>
    return (
        <div className="vehicleCategories">
            <Header />
            <main id="main" className="main">
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title"> Student Enrollment Information</h5>
                    <ul className="nav nav-tabs nav-tabs-bordered d-flex" id="borderedTabJustified" role="tablist">
                       <li className="nav-item flex-fill" role="presentation">
                        <button className="nav-link w-100 active" id="home-tab" data-bs-toggle="tab" data-bs-target="#bordered-justified-home" type="button" role="tab" aria-controls="home" aria-selected="true">Student Enrollment Information</button>
                        </li>
                        <li className="nav-item flex-fill" role="presentation">
                        <button className="nav-link w-100" id="profile-tab" data-bs-toggle="tab" data-bs-target="#bordered-justified-profile" type="button" role="tab" aria-controls="profile" aria-selected="false">Add Enrollment Information</button>
                        </li>
                    </ul>
                    <div className="tab-content pt-2" id="borderedTabJustifiedContent">
                        <div className="tab-pane fade show active" id="bordered-justified-home" role="tabpanel" aria-labelledby="home-tab"> 
                            <section className="section">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="card">
                                            <div className="card-body table-responsive">
                                                <h5 className="card-title"> Student Enrollment Information</h5>
                                                <div className='row'>
                                                    <div className='col-lg-8'></div>
                                                    <div className='col-lg-4'>
                                                        <div className="datatable-search pull-right">
                                                            <input className="datatable-input" placeholder="Search..." type="search" title="Search within table" onChange={findSearch}/>
                                                        </div>
                                                    </div>
                                                </div>
                                                <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th>#</th>
                                                                <th className='text-capitalize'>learner name</th>
                                                                <th className='text-capitalize'>email</th>
                                                                <th className='text-capitalize'>mobile no</th>
                                                                <th className='text-capitalize'>course</th>
                                                                <th className='text-capitalize'>license vilidity</th>
                                                                <th className='text-capitalize'>start date</th>
                                                                <th className='text-capitalize'>end date</th>
                                                                <th className='text-capitalize'>platform</th>
                                                                <th className='text-capitalize'>action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody> 
                                                        {
                                                            getEnrollment?.data?.data_array?.map((item,index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    <th scope="row">{index+1}</th>
                                                                    <td>{item.student?.first_name}{item.student?.last_name} </td>
                                                                    <td>{item.student?.email}</td>
                                                                    <td>{item.student?.mobile_number}</td>
                                                                    <td>{item.course?.course_name}</td>
                                                                    <td>{item.license_expiry?.validity}</td>
                                                                    <td>{item.start_date}</td>
                                                                    <td>{item.end_date}</td>
                                                                    <td>{item.student?.platform ===1 ? "QHSE E-Learning":"TWI"}</td>
                                                                   
                                                                    <td>
                                                                       <DeleteEnroll id={item.enroll_id} />
                                                                    </td>
                                                                </tr>                                            
                                                                )  
                                                            })  
                                                        } 
                                                        </tbody>
                                                </table>                        
                                                <nav aria-label="Page navigation example">
                                                    <ul className="pagination">
                                                    {getEnrollment?.data?.currentPage !==0 ? <li className="page-item"><button type="button" className="page-link" onClick={getPrevious}>Previous</button></li> :''}
                                                    <li className="page-item"> {getEnrollment?.data?.currentPage+1} </li>                                                  
                                                    <li className="page-item"> of {getEnrollment?.data?.totalPages}</li>
                                                    {getEnrollment?.data?.currentPage !==getEnrollment?.data?.totalPages ? <li className="page-item"><button type="button" className="page-link" onClick={getNext}>Next</button></li>:''}
                                                    </ul>
                                                </nav>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>  
                        </div>
                       <AddEnroll />
                    </div>
                </div>
            </div>
            </main>
           
        </div>
    );
}
